import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Evoryn } from '../../Servcie/evoryn';
import { ToastrNotificationService } from '../../Common/toastr-notification.service';
import { SearchService } from '../../Service/search';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-order-commission',
  standalone: true,
  imports: [CommonModule],
  providers: [DatePipe],
  templateUrl: './order-commission.html',
  styleUrls: ['./order-commission.css']
})
export class OrderCommission implements OnInit, OnDestroy {

  totalEarned: number = 0;
  availableBalance: number = 0;


  allCommissions: any[] = [];
  filteredCommissions: any[] = [];

  currentSearchText: string = '';
  private searchSubscription!: Subscription;

  constructor(
    private api: Evoryn,
    private toastr: ToastrNotificationService,
    private datePipe: DatePipe,
    private searchService: SearchService
  ) { }

  ngOnInit(): void {

    this.searchSubscription = this.searchService.currentSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(text => {
        this.currentSearchText = text;
        this.applyFilter();
      });


    this.fetchCommissions();
  }

  ngOnDestroy(): void {

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  fetchCommissions() {
    const sessionUserId = Number(sessionStorage.getItem('userID')) || 0;

    const payload = {
      partnerUserID: sessionUserId,
      pageNumber: 0,
      pageSize: 50
    };

    this.api.fetchordercommission(payload).subscribe({
      next: (res: any) => {
        if (res.status && res.data) {
          this.totalEarned = res.data.totalEarned || 0;
          this.availableBalance = res.data.balance || 0;


          this.allCommissions = (res.data.commission || []).map((item: any, index: number) => ({
            srNo: (index + 1).toString().padStart(2, '0'),
            orderId: `#ORD-${item.orderCommissionID}`,
            price: item.orderTotal || 0,
            date: this.datePipe.transform(item.orderDate, 'dd MMM yyyy') || 'N/A',
            commission: item.commissionEarned || 0
          }));
        } else {
          this.allCommissions = [];
        }


        this.applyFilter();
      },
      error: (err) => {
        this.toastr.showError('Failed to fetch commission data.');
        console.error('API Error:', err);
      }
    });
  }


  applyFilter() {
    if (!this.currentSearchText || this.currentSearchText.trim() === '') {

      this.filteredCommissions = [...this.allCommissions];
    } else {

      const searchStr = this.currentSearchText.toLowerCase().trim();
      this.filteredCommissions = this.allCommissions.filter(item =>
        (item.orderId && item.orderId.toLowerCase().includes(searchStr)) ||
        (item.date && item.date.toLowerCase().includes(searchStr))
      );
    }
  }
}